/*
  assets/c-product-sticky-cart.js
  商品ページ下部の固定カートバー（作業管理 No.12）

  やっていることは3つだけ。カート追加そのものには一切関与しない
  （送信ボタンは button[form=...] で上部の product-form を直接叩いている）。

  1. 表示制御 : 上部の「カートに追加」を IntersectionObserver で監視し、
                画面外に出ている間だけバーを出す
  2. 価格同期 : バリアント変更で #price-* が差し替わるので、その文字列をミラーする
  3. 状態同期 : 上部ボタンの disabled とラベル（売り切れ等）をミラーする
*/
(function () {
  'use strict';

  function textOf(el) {
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function init(root) {
    var trigger = document.querySelector(root.getAttribute('data-sticky-cart-trigger'));
    var submit = root.querySelector('[data-sticky-cart-submit]');
    var label = root.querySelector('[data-sticky-cart-label]');
    var price = root.querySelector('[data-sticky-cart-price]');
    var priceSource = document.querySelector(root.getAttribute('data-sticky-cart-price-source'));

    // 上部のボタンが無い商品（在庫なし等で product-form ごと出ない）では何もしない
    if (!trigger || !submit) return;

    // --- 1. 表示制御 -------------------------------------------------
    // バーの高さを CSS 変数で公開する。LINE 相談バナーを何 px 持ち上げるかに使う
    // （c-product-sticky-cart.css の body.has-sticky-cart .guest-line-banner）
    function setVisible(visible) {
      root.classList.toggle('is-visible', visible);
      document.body.classList.toggle('has-sticky-cart', visible);
      if (visible) {
        document.documentElement.style.setProperty(
          '--sticky-cart-height',
          root.offsetHeight + 'px'
        );
      }
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            setVisible(!entry.isIntersecting);
          });
        },
        // ヘッダー・フッターに半分かかった状態では「見えている」扱いにしない
        { threshold: 0, rootMargin: '0px 0px -40px 0px' }
      ).observe(trigger);
    }

    // --- 2 / 3. 本体のミラー ------------------------------------------
    function syncState() {
      var disabled = trigger.hasAttribute('disabled');
      if (disabled) {
        submit.setAttribute('disabled', '');
      } else {
        submit.removeAttribute('disabled');
      }

      // 上部ボタンは <span>ラベル</span> + ローディングスピナー の構成。
      // spinner のテキストまで拾わないよう span だけを見る
      var sourceLabel = textOf(trigger.querySelector('span'));
      if (label && sourceLabel) label.textContent = sourceLabel;
    }

    // #price-* の中には表示価格のほかに、読み上げ用の visually-hidden なラベル
    // （「通常価格」「単価」）と配送注記まで入っている。丸ごと textContent を取ると
    // 「通常価格 ¥82,500 単価 / あたり 税込 配送料：…」になってしまうので、
    // 金額そのものの要素だけを拾う。セール中は price__sale 側が表示される。
    function priceText() {
      var items = priceSource.querySelectorAll(
        '.price__sale .price-item--sale, .price__regular .price-item--regular'
      );
      for (var i = 0; i < items.length; i++) {
        if (items[i].offsetParent !== null) return textOf(items[i]);
      }
      // 表示中の判定が付かない場合（親ごと非表示など）は先頭を使う
      return textOf(items[0]) || textOf(priceSource.querySelector('.price-item'));
    }

    function syncPrice() {
      if (!price || !priceSource) return;
      var text = priceText();
      if (text) price.textContent = text;
    }

    syncState();
    syncPrice();

    if ('MutationObserver' in window) {
      new MutationObserver(syncState).observe(trigger, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        subtree: true,
        characterData: true,
      });

      if (priceSource) {
        new MutationObserver(syncPrice).observe(priceSource, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }
    }
  }

  function boot() {
    document.querySelectorAll('[data-sticky-cart]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
